import { Component, EventEmitter, Output  } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter,MAT_DATE_LOCALE, } from '@angular/material';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login/login.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-cambiar-contrasena',
  templateUrl: './cambiar-contrasena.component.html',
  styleUrls: ['./cambiar-contrasena.component.scss'],
  providers: [
    DatePipe,DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
  ]
})
export class CambiarContrasenaComponent   {
  id_user: any;
  loading: boolean = false;
  data: any;
  formCambiarContrasena: FormGroup;

  @Output() CerrarPopUpCambiarContrasena: EventEmitter<boolean>;
  
  constructor(private loginService:LoginService, private router: Router, private _route: ActivatedRoute, private formBuilder: FormBuilder) 
  {
    this.CerrarPopUpCambiarContrasena = new EventEmitter();
    let user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.id_user = user.id_user;

    this.formCambiarContrasena = new FormGroup({
      id_usuario : new FormControl(this.id_user),
      id_empresa : new FormControl("4"),
      password: new FormControl("", [Validators.required, Validators.minLength(6) ]),
      repetir_Password: new FormControl("", [Validators.required, Validators.minLength(6) ])
    },
    this.passwordsShouldMatch,
    )
  }
  private passwordsShouldMatch(fGroup: FormGroup) {
    return fGroup.get('password').value === fGroup.get('repetir_Password').value
      ? null : {'mismatch': true};
  }

 
  CambiarContrasena(){
    if (this.formCambiarContrasena.invalid) {
      Swal.fire({
        title: "PASSWORD NO COINCIDE",
        text: "Verificar que las contraseñas coincidan",
        type: "warning",
        allowOutsideClick: false
      })
      return;
    }
    
    this.loading = true;
    this.loginService.cambiarContraseña(this.formCambiarContrasena.getRawValue()).subscribe(
      resp => {
        this.data = resp;
        this.loading = false;
        Swal.fire({
          title: "¡Éxito!",
          text: "La contraseña ha sido modificada correctamente.",
          type: "success",
          allowOutsideClick: true
        }).then(resp1 => {
          if (resp1.value == true){
            this.router.navigate(['/login']);
          }
        }); 

      },
      err => {       
        this.loading = false;
        Swal.fire({
          title: "Error",
          text: "Usuario o Contraseña Incorrectos",
          type: "error",
          allowOutsideClick: true
        });          
      }
    );
    
  }

  CerrarPopUpCC(){
    this.CerrarPopUpCambiarContrasena.emit();
  }
}
